var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMysFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.047 3.74h59.906v3.6H.047v-3.6Zm0 7.379h59.906v3.6H.047v-3.6Zm0 7.387h59.906v3.6H.047v-3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .047h30v26.25H0V.047Z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.453 6.919.563 3.815 2.156-3.187-1.163 3.675 3.328-1.95-2.634 2.812 3.844-.3-3.59 1.388 3.59 1.387-3.844-.3 2.634 2.813-3.328-1.95 1.153 3.684-2.156-3.197-.562 3.816-.553-3.816-2.157 3.188 1.163-3.675-3.328 1.95 2.625-2.813-3.844.3 3.6-1.387-3.59-1.388 3.843.3-2.634-2.812 3.328 1.95-1.163-3.684 2.157 3.196.562-3.815Zm-3.122.16a6.666 6.666 0 1 0 0 12.187 7.5 7.5 0 1 1 0-12.188Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.047 25.894h59.906v3.6H.047v-3.6Zm0 7.33h59.906v3.6H.047v-3.6ZM0 41.4h59.906V45H0v-3.6Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysFlag);
export default __webpack_public_path__ + "static/media/mys-flag.8a23e73cdde52d032d916908d166a055.svg";
export { ForwardRef as ReactComponent };